const colorBrightGreen = '#A5D45D';
const colorDarkBlue = '#202B2f';
const colorDarkGreen = '#457200';
const colorDarkTeal = '#007672';
const colorLightGrey = '#F0F2F2';
const colorLightTeal = '#279F9B';
const colorLightBlue = '#EAF3F2';
const colorMediumBlue = '#365B70';
const colorMediumGreen = '#8dc059';
const colorMediumGrey = '#D9D9D9';
const colorRed = '#D1313B';
const colorLightBackground = '#F9FAFA';

export {
    colorBrightGreen,
    colorDarkBlue,
    colorDarkGreen,
    colorDarkTeal,
    colorLightGrey,
    colorLightTeal,
    colorLightBlue,
    colorMediumBlue,
    colorMediumGreen,
    colorMediumGrey,
    colorRed,
    colorLightBackground,
}